import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from '../config';
import Cookies from 'js-cookie';

import { Box, Button, Checkbox, FormControlLabel, Paper, Typography } from '@mui/material';

const Logs = () => {
    const [lines, setLines] = useState([])
    const [error, setError] = useState('')
    const [auto, setAuto] = useState(true)
    const box = useRef(null)

    const load = useCallback(async () => {
        try {
            const response = await axios.get('ulogs', { headers: { token: Cookies.get('token') } })
            setLines(response.data.lines || [])
            setError('')
        } catch (err) {
            setError('Журнал сейчас недоступен')
        }
    }, [])

    useEffect(() => {
        load()
    }, [load])

    useEffect(() => {
        if (!auto) {
            return
        }
        const timer = setInterval(load, 5000)
        return () => clearInterval(timer)
    }, [auto, load])

    useEffect(() => {
        if (box.current) {
            box.current.scrollTop = box.current.scrollHeight
        }
    }, [lines])

    return (
        <Paper sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6">Журнал</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        sx={{ ml: 0, mr: 1 }}
                        control={
                            <Checkbox
                                size="small"
                                checked={auto}
                                onChange={(event) => setAuto(event.target.checked)}
                                sx={{ p: '4px' }}
                            />
                        }
                        label={<Typography sx={{ fontSize: 13, ml: '2px' }}>Автообновление</Typography>}
                    />
                    <Button size="small" onClick={load}>Обновить</Button>
                </Box>
            </Box>
            <Typography variant="body2" sx={{ color: '#7f7f7f', mb: 1 }}>
                {error || (auto ? `${lines.length} строк, обновление каждые 5 секунд` : `${lines.length} строк`)}
            </Typography>
            <Box
                component="pre"
                ref={box}
                sx={{
                    m: 0,
                    p: 1.5,
                    maxHeight: '70vh',
                    overflow: 'auto',
                    bgcolor: '#1e1e1e',
                    color: '#d6d6d6',
                    fontSize: 12,
                    lineHeight: 1.45,
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                }}
            >
                {lines.length ? lines.join('\n') : 'Записей пока нет'}
            </Box>
        </Paper>
    )
}

export default Logs
